import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 12h-12","key":"svg-0"}],["path",{"d":"M13 16l-4 -4l4 -4","key":"svg-1"}],["path",{"d":"M12 3a9 9 0 1 0 0 18","key":"svg-2"}]]

const IconArrowLeftToArc = createReactComponent('outline', 'arrow-left-to-arc', 'ArrowLeftToArc', __iconNode);

export default IconArrowLeftToArc;